import Axios from 'axios'
export const normalClient = Axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT || 'http://localhost:8088',
  withCredentials: true
})
// for hanlp
export const hanlpClient = Axios.create({
  baseURL: 'https://ai.voiss.cc'
})

export const ckipClient = Axios.create({
  baseURL: 'https://614cbfaa.ngrok.io'
})

export default normalClient

if(process.env.NODE_ENV !== 'production'){
  window.hanlpClient = hanlpClient
  window.ckipClient = ckipClient
}
